module.exports = __webpack_public_path__ + "img/Frame.0a0858ea.svg";